import { jsxs, jsx } from "react/jsx-runtime";
const NotificationErrorIcon = () => /* @__PURE__ */ jsxs("svg", { width: "200", height: "180", viewBox: "0 0 200 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M30.3438 30.732L43.1663 23.357C49.3309 19.7924 57.5916 19.5465 66.9619 23.234L54.1394 30.6091C44.7691 26.9216 36.5084 27.1674 30.3438 30.732Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M172.008 162.252L159.185 169.627C165.103 166.185 168.802 159.056 168.802 148.854C168.926 129.925 156.35 106.94 139.705 94.1563L152.528 86.7812C169.172 99.5646 181.625 122.55 181.625 141.479C181.625 151.681 178.049 158.81 172.008 162.252Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M64.127 18.3168L76.9495 10.9418C84.9635 6.27095 96.4298 7.00845 109.006 14.2605C133.048 28.1501 152.405 60.4772 152.528 86.9043L139.706 94.2793C139.582 67.9751 120.225 35.5251 96.1832 21.6355C83.6073 14.3834 72.141 13.6459 64.127 18.3168Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M139.705 94.1557C139.581 67.8515 120.224 35.4015 96.1822 21.5119C76.7019 10.3265 59.934 14.6286 54.2625 30.4849C34.1657 22.6182 19.1239 32.8203 19.0006 55.5599C18.8773 80.8807 37.7412 112.224 61.0436 125.622C62.2766 126.36 63.5095 126.974 64.7424 127.589L133.047 167.045C133.663 167.414 134.28 167.66 134.773 167.783C153.637 177.739 168.679 169.504 168.679 148.977C168.925 129.924 156.349 106.939 139.705 94.1557Z",
      fill: "url(#paint0_linear)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M73.4613 139.756C73.2226 139.198 72.9839 138.686 72.6975 138.174L52.98 95.7697C52.3116 94.3268 50.1632 94.3268 49.4948 95.7697L30.6844 136.405C29.6818 138.034 28.8225 139.803 28.2495 141.665C27.5812 143.853 27.1992 146.18 27.1992 148.554C27.1992 161.494 37.9412 171.967 51.2135 171.967C64.4858 171.967 75.2278 161.494 75.2278 148.554C75.2278 145.482 74.6071 142.456 73.4613 139.756Z",
      fill: "#C9C9C9"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: "paint0_linear", x1: "84.6", y1: "39.6279", x2: "58.8286", y2: "189.571", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#F4F4F4" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#C9C9C9" })
  ] }) })
] });
export {
  NotificationErrorIcon
};
//# sourceMappingURL=NotificationErrorIcon.js.map
